export const DONATE_URI = 'https://www.ecmnederland.nl/ik-steun-knol';